import { fromJS } from 'immutable';
import config from 'react-global-configuration';
import { API_REQUEST } from '../actions/api';

const apiMiddleware = ({ dispatch }) => (next) => (action) => {
  if (action.type === API_REQUEST) {
    const { path, successHandler, successCallback } = action;
    let API_URL = config.get('API_URL');
    // Replace for "development" ENV URL path
    if (API_URL.startsWith('//')) {
      API_URL = API_URL.replace('//', 'http://');
    }
    const basePath = `${API_URL}/`;
    const url = `${basePath}${path}`;

    fetch(url).then((response) => {
      if (response.ok) {
        response.json().then((result) => {
          if (successHandler) {
            dispatch(successHandler(fromJS(result)));
          }
          if (successCallback) {
            successCallback();
          }
        });
      }
    }).catch(() => {
      console.error('Unable to complete request.');
    });
  }
  return next(action);
};

export default apiMiddleware;
